import { ElMessage } from 'element-plus'

interface ParseParamsObj {
  [key: string]: (string | number)[] | string | number | boolean
}
export const parseParam = (url: string): ParseParamsObj => {
  const paramsRegExpArr: RegExpExecArray | null = /.+\?(.+)$/.exec(url)

  // eslint-disable-next-line id-length, no-unused-vars
  const [, paramStr] = paramsRegExpArr || []
  const paramsArr: string[] = paramStr.split('&') || []

  const paramsObj: ParseParamsObj = {}

  paramsArr.map((param) => {
    if (/=/.test(param)) {
      // eslint-disable-next-line prefer-const
      let [key, value] = param.split('=')
      value = decodeURIComponent(value)
      const val = /^\d+$/.test(value) ? parseFloat(value) : value

      if (paramsObj.hasOwnProperty(key) && Array.isArray(paramsObj[key])) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        paramsObj[key] = [...paramsObj[key], val]
      } else {
        paramsObj[key] = val
      }
    } else {
      paramsObj[param] = true
    }
  })
  return paramsObj
}

export const deepClone = (obj: {}, hash = new WeakMap()) => {
  if (obj instanceof RegExp) return new RegExp(obj)
  if (obj instanceof Date) return new Date(obj)
  if (obj === null || typeof obj !== 'object') return obj
  if (hash.has(obj)) {
    return hash.get(obj)
  }
  // @ts-ignore
  const constr = new obj.constructor()
  hash.set(obj, constr)
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      // @ts-ignore
      constr[key] = deepClone(obj[key], hash)
    }
  }

  return constr
}

export function debounce<T extends (...args: any[]) => any>(
  fn: T,
  delay = 300
): (...args: Parameters<T>) => void {
  let timer: ReturnType<typeof setTimeout> | null = null

  return function (...args: Parameters<T>): void {
    if (timer) {
      clearTimeout(timer)
    }
    timer = setTimeout(() => {
      // @ts-ignore
      fn.apply(this, args)
    }, delay)
  }
}

export const formatXml = (xml: string) => {
  let formatted = ''
  const reg = /(>)(<)(\/*)/g
  xml = xml.replace(reg, '$1\r\n$2$3')
  let pad = 0

  xml.split('\r\n').forEach((node) => {
    let indent = 0
    if (node.match(/.+<\/\w[^>]*>$/)) {
      indent = 0
    } else if (node.match(/^<\/\w/)) {
      if (pad !== 0) {
        pad -= 1
      }
    } else if (node.match(/^<\w[^>]*[^\/]>.*$/)) {
      indent = 1
    } else {
      indent = 0
    }

    let padding = ''
    for (let i = 0; i < pad; i++) {
      padding += '  '
    }

    formatted += `${padding + node}\r\n`
    pad += indent
  })

  return formatted
}

export const checkTicketNumberValid = (ticketNum: string) => {
  const ticketTypeList = ['CHG', 'INC', 'RITM', 'ISSUE']
  ticketNum = ticketNum.toUpperCase()

  if (ticketNum.startsWith('WO') || ticketNum.startsWith('WCR')) {
    return false
  }

  const reg = /^[0-9]*[1-9][0-9]*$/
  let size = 12

  for (let i = 0; i < ticketTypeList.length; i++) {
    const ticketType = ticketTypeList[i]
    const ticketTypeLen = ticketType.length
    if (
      ticketType.trim() === 'CHG' ||
      ticketType.trim() === 'INC' ||
      ticketType.trim() === 'RITM' ||
      ticketType.trim() === 'ISSUE'
    ) {
      size = 7
    }
    if (
      ticketNum.indexOf(ticketType) === 0 &&
      reg.test(ticketNum.substring(ticketTypeLen)) &&
      ticketNum.length === size + ticketTypeLen
    ) {
      return true
    }
  }
  return false
}

export const downLoadXML = (xmlData: string, fileName: string) => {
  try {
    const blob = new Blob([xmlData], { type: 'text/plain;charset=utf-8' })

    const downloadLink = document.createElement('a')
    downloadLink.href = URL.createObjectURL(blob)
    downloadLink.download = `${fileName}.xml`
    downloadLink.dispatchEvent(new MouseEvent('click'))
    URL.revokeObjectURL(downloadLink.href)
  } catch (error) {
    ElMessage({
      message: `Failed to download ${fileName} xml.`,
      type: 'error'
    })
    console.log(error)
  }
}

export const isObj = (obj: any) => {
  return obj !== null && typeof obj === 'object' && !Array.isArray(obj)
}

export const isEmptyObject = (obj: any) => {
  return isObj(obj) && Object.keys(obj).length === 0
}

export const getNumberFromStr = (str: string) => {
  let res = ''
  for (const a of str) {
    if (/\d/.test(a)) {
      res += a
    }
  }
  return res
}

export const bigIntAdd = (intA: string, intB: string) => {
  const bigNum = BigInt(intA) + BigInt(intB)
  return bigNum.toString()
}

export const convertCamelToTitle = (camelCaseString: string) => {
  return camelCaseString
    .replace(/([A-Z])/g, ' $1')
    .replace(/^./, (match) => match.toUpperCase())
}
